import { mobileMenu } from "./utilities/Menu/mobileMenu";
import { isDesktop } from "./utilities/screenSize";
import { initializeComponents } from "./utilities/Global/initializeComponents";
import * as Thumbnail from "./utilities/thumbnail";
import { responsiveVideo } from "./utilities/responsiveVideo";
import { Video } from "./utilities/video";
import ABTests from "./utilities/ABTests/ABTests";
import { calculateAspectRatio } from "./utilities/objectFitImages";
import Alpine from "alpinejs";
import mask from "@alpinejs/mask";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import { lcFirst } from "./utilities/Helpers/helpers";
import desktopMenu from "./utilities/Header/desktopHeader";
import { Gender } from "./utilities/Gender";
import Sentry from "./utilities/Log/Sentry";
import Cart from "./utilities/Cart/Cart.js";
import { a11yInitHelper, setFocusOnCookieConsentWhenLoaded } from "./utilities/Helpers/AccesibilityHelper";
import { alpineGlobalComponent } from "./utilities/Global/AlpineGlobal";
import miniCart from "./utilities/Cart/MiniCart";
import CartStore from "./utilities/Cart/CartStore";

import { changeSwatchesRoleToPresentationInPLP } from "./utilities/Helpers/UI/SwatchHelperToA11y";
import NobiAb from "./utilities/ABTests/NOBI";
import mobileSubmenu from "./utilities/Menu/mobileSubmenu";

changeSwatchesRoleToPresentationInPLP();
Sentry();

window.Alpine = Alpine;

Alpine.plugin(mask);
Alpine.plugin(focus);
Alpine.plugin(collapse);

window.LUC = window.LUC || {};
LUC.Modals = LUC.Modals || {};
LUC.ABTests = LUC.ABTests || {};

ABTests();
Gender.init();

NobiAb();

$(function () {
    initializeComponents();

    var resizeTimer;

    // Store window width in variable
    $(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            calculateAspectRatio();
            if (isDesktop()) {
                // When larger than 798
                // Swatches
                Thumbnail.enableSwatches();
            }
        }, 250);
    });

    //Enable plyr
    Video.init();

    /* Show secondary image on hover */

    Thumbnail.showVariantImage();
    Thumbnail.enableSwatches();

    // Tabs
    if ($(".tabs").length > 0 || $("[data-tabs]").length > 0) {
        require("./utilities/tabs");
        LUC.tabs.enableTabs();
    }

    // Responsive Video
    responsiveVideo.init();

    // Limit Newsletter input to 64 characters
    setTimeout(function () {
        $(".klaviyo-form input[type=email]").prop("maxLength", 64);
    }, 3000);

    initializationAlpineAfterLoaded();
    a11yInitHelper();
    setFocusOnCookieConsentWhenLoaded();
});

function initializationAlpineAfterLoaded() {
    let keys = Object.keys(LUC);
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (typeof LUC[key].alpine !== "undefined") {
            let alpineData = key.replace(/^(js)?(.*)/, "$2");
            alpineData = lcFirst(alpineData);
            Alpine.data(alpineData, () => LUC[key]);
        }
    }
    Alpine.data("mobileMenu", () => mobileMenu);
    Alpine.data("mobileSubmenu", mobileSubmenu);
    Alpine.data("desktopMenu", desktopMenu);
    Alpine.data("alpineCart", Cart);
    Alpine.data("miniCart", miniCart);
    Alpine.data("global", alpineGlobalComponent);

    Alpine.store("cart", CartStore());

    Alpine.start();
}
